//getters
export const GET_REFERRAL_RESULTS = 'getReferralResults';
export const GET_REFERRAL_FILTERS = 'getReferralFilters';

//mutations
export const SET_REFERRAL_RESULTS = 'setReferralResults';
export const SET_REFERRAL_FILTER = 'setReferralFilter';
export const SET_REFERRAL_DETAILS = 'setReferralDetails';
export const SET_REFERRAL_DETAILS_COLLAPSE = 'setReferralItemCollapse';
export const SET_REFERRAL_DETAILS_SERVICE_COLLAPSE = 'setReferralServiceItemCollapse';
export const SET_REFERRAL_MODEL = 'setReferralModel';
export const SET_REFERRAL_CURRENT_FILTERS = 'setReferralCurrentFilters';
export const SET_REFERRAL_TABLE_CONFIG = 'setReferralTableConfig';

export const SET_REFERRAL_SELECTED_ACADEMY_YEAR =
  'setFilterSelectedAcademicYear';
export const SET_REFERRAL_SELECTED_DISCIPLINE = 'setFilterSelectedDiscipline';
export const SET_REFERRAL_SELECTED_MUNICIPALITY =
  'setFilterSelectedMunicipality';
export const SET_REFERRAL_SELECTED_CENTER = 'setFilterSelectedCenter';
export const SET_REFERRAL_SELECTED_SCHOOL = 'setFilterSelectedSchool';
export const SET_REFERRAL_SELECTED_ADMISSION_STATUS =
  'setFilterSelectedAdmissionStatus';
export const SET_REFERRAL_SELECTED_ADMISSION_STATUS_REASONS =
  'setFilterSelectedStatusReasons';
export const SET_REFERRAL_SELECTED_ADMISSION_REFERRAL_TYPES =
  'setFilterSelectedReferralTypes';

export const SET_REFERRAL_IS_ADVANCED_FILTER = 'setReferralIsAdvancedFilter';
export const SET_REFERRAL_DISABLED_CENTER = 'setReferralDisabledCenter';
export const SET_REFERRAL_DISABLED_MUNICIPALITY =
  'setReferralDisabledMunicipality';
export const SET_REFERRAL_DISABLED_SCHOOL = 'setReferralDisabledSchool';
export const SET_REFERRAL_DISABLED_ADMISSION_STATUS_REASON =
  'setReferralDisabledAdmissionStatusReason';
export const SET_REFERRAL_SEARCH_TEXT = 'setReferralSearchText';
export const SET_REFERRAL_SELECTED_FILTER = 'setReferralSelectedFilter';
export const SET_REFERRAL_RADIO_BTN_SELECTED = 'setReferralRadioBtnSelected';
export const SET_REFERRAL_SELECTED_FILTER_TYPE =
  'setReferralSelectedFilterType';
export const SET_REFERRAL_SERVICE_CENTER = 'setReferralServiceCenter';
export const SET_REFERRAL_RESET_SELECTION = 'setReferralResetSelection';
export const SET_REFERRAL_NEW_BILLING_CENTER = 'setReferralNewBillingCenter';
export const SET_REFERRAL_ACTION_TYPE = 'setReferralActionType';
export const SET_REFERRAL_REJECTION_REASON = 'setReferralRejectionReason';
export const SET_CLEAR_FILTERS = 'setClearFilters';

export const MUTATION_TYPES = {
  //General Filters
  SET_REFERRAL_ACADEMY_YEAR: 'setFilterAcademyYear',

  //Standard Filter
  SET_REFERRAL_SCHOOL: 'set-referral-school',

  //Standard & Advanced Filters
  SET_REFERRAL_MUNICIPALITIES: 'set-referral-municipalities',
  SET_REFERRAL_ADMISSION_STATUS: 'set-referral-admission-status',
  SET_REFERRAL_ADMISSION_STATUS_REASONS: 'set-referral-status-reasons',
  SET_REFERRAL_ADMISSION_REFERRAL_TYPES:
    'set-referral-admission-referral-types',
  SET_SERVICE_MODALITY_TYPES: 'set-services-modality-types',

  //Standard & Waiting List Filters
  SET_REFERRAL_DISCIPLINE: 'set-referral-discipline',
  //Advanced Filters
  SET_REFERRAL_MONTHS: 'set-referral-months',
  SET_REFERRAL_PROVIDERS: 'set-referral-providers',
  SET_REFERRAL_LOCATIONS_SERVICES: 'set-referral-locations_services',
  SET_REFERRAL_LOCATION_TYPES: 'set-referral-location-types',
  SET_REFERRAL_SPECIALISTS: 'set-referral-specialists',

  //Advanced & Waiting List Filters
  SET_REFERRAL_CENTERS: 'set-referral-centers',

  SET_CURRENT_FILTERS: 'setCurrentFilters',

  // Admission Rejection History
  SET_ADMISSION_REJECTION_HISTORY: 'setAdmissionRejectionHistory',
  //TempS
  //temp to delete selected Mutation :/
  SET_SELECTED_ACADEMIC_YEAR_BY_FILTER: 'set-selected-academic-year-by-filter',
};
//actions Think is need to do this? (Only if is calling )
export const ACTION_TYPES = {
  GET_REFERRALS: 'getReferrals',
  GET_REFERRAL_DETAILS: 'getReferralsDetails',
  //Commons
  GET_FILTERS: 'getFilters',
  //GET_FILTERS STANDARD & ADVANCED
  GET_FILTERS_BY_STATUS: 'getFiltersByStatus',

  //GET_FILTERS ADVANCED BY
  GET_FILTERS_BY_PROVIDER: 'getFiltersByProvider',
  GET_FILTERS_BY_CENTER: 'getFiltersByCenter',
  GET_FILTERS_BY_MUNICIPALITY: 'getFiltersByMunicipality',
  GET_FILTERS_BY_LOCATION_SERVICE: 'getFiltersByLocationService',
  GET_FILTERS_BY_LOCATION_TYPE: 'getFiltersByLocationType',
  NONE: 'none',
  GET_BILLING_CENTERS: 'getBillingCenters',
  UPDATE_BILLING_CENTER: 'updateBillingCenter',

  //Vinculación de referido
  GET_ADMISSION_REJECTION_HISTORY: 'getAdmissionrejectionhistory',
  GET_REFERRAL_REJECTION_REASON: 'getReferralRejectionReason',
  DENEGATE_REFERRAL: 'denegateReferral',
};
